import FormgroupPage from "../formgroup/FormgroupPage";
import React from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { FormLabel, FormControl } from "../formgroup/FormgroupPage";
import ButtonPage from "../button/ButtonPage";
import SelectunitPage from "../customselect/SelectunitPage";
import SingleselectPage from "../customselect/SingleselectPage";

function VariationboxPage(props) {

  const { t } = useTranslation();

  const selectedUnitrender = (selectedUnit) => {
    if (selectedUnit?.length !== 0 && typeof selectedUnit !== "undefined") {
      selectedUnit = {
        ...selectedUnit,
        label:
          props.language === "Tr" ? selectedUnit.label_tr : selectedUnit.label,
      };
      return selectedUnit?.label;
    } else {
      return "";
    }
  };

  const unitListrender = (unitlist) => {
    let updatedunitlist = [];
    unitlist.forEach((item) => {
      updatedunitlist.push({
        value: item?.value,
        label: props?.language === "Tr" ? item?.label_tr : item?.label,
        label_tr: item?.label_tr,
      });
    });
    return updatedunitlist;
  };

  return (
    <Card className="variation-box">
      <Card.Body>
        <Row>
          <Col sm={12} md={3} lg={3} xl={3}>
            <FormgroupPage label={t("pages.add_product.qty")}
              placeholder={t("pages.add_product.qty_place")} value={props?.addVariant?.quantity} name={"quantity"} type={"text"} onChange={props?.addVariantchange}
              error={t(props?.errorVariant?.quantity)} />
          </Col>
          <Col sm={12} md={3} lg={3} xl={3} className="position-relative">
            <FormLabel label={t("pages.add_product.units")}></FormLabel>
            {props?.type === "unit_list" ? (
              <SelectunitPage
                groupItemClick={props?.selectUnitchange}
                value={selectedUnitrender(props?.selectUnit)}
                placeholder={t("pages.add_product.unites")}
                list={unitListrender(props?.unitlist)}
                uniListopen={props?.unitListopen}
                unitListclose={props?.unitListclose}
                variation_index={props?.index}
                showunits={props?.showunits}
              />
            ) : (
              <>
                <SingleselectPage
                  groupItemClick={props?.selectUnitchange}
                  list={unitListrender(props?.unitlist)}
                  setShowList={props?.setShowcategorylist}
                  showList={props?.showCategorylist}
                  placeholder={t("pages.add_product.unites")}
                  value={selectedUnitrender(props?.selectUnit)}
                  inputClassName={"units"}
                />
                <div className="text-danger mt-1">
                  {t(props?.errorVariant?.unit)}
                </div>
              </>
            )}
          </Col>
          <Col sm={12} md={3} lg={3} xl={3}>
            <FormgroupPage label={t("pages.add_product.price") + " " + process.env.REACT_APP_CURRENCY_SYMBOL}
              placeholder={t("pages.add_product.price_place")} value={props?.addVariant?.price} name={"price"} type={"number"} onChange={(e) => props?.addVariantchange(e)}
              error={t(props?.errorVariant?.price)} />
          </Col>
          <Col sm={12} md={3} lg={3} xl={3}>
            <FormgroupPage label={t("pages.Product discount price") + " " + process.env.REACT_APP_CURRENCY_SYMBOL}
              placeholder={t("pages.add_product.discount_place")} value={props?.addVariant?.discount} name={"discount"} type={"number"} onChange={(e) => props?.addVariantchange(e)}
              error={t(props?.errorVariant?.discount)} />
          </Col>
        </Row>
        <Row className="align-items-baseline mt-2">
          <FormLabel label={t("pages.Stock")}></FormLabel>
          <Col sm={12} md={3} lg={2} xl={2}>
            <Form.Check
              id={props?.list ? props?.index + "variation_always" : "always"}
              label={t("pages.add_product.always")}
              className="radio-btn"
              onChange={props?.instockvariantChange}
              type="radio"
              checked={
                props?.addVariant?.is_stock === "yes" ? false : true
              }
            />
          </Col>
          <Col sm={12} md={3} lg={2} xl={2}>
            <Form.Check
              id={props?.list ? props?.index + "variation_limited" : "limited"}
              onChange={props?.instockvariantChange}
              type="radio"
              label={t("pages.add_product.limited")}
              className="radio-btn"
              style={{ marginLeft: "1rem" }}
              checked={
                props?.addVariant?.is_stock === "yes" ? true : false
              }
            />
          </Col>
          <Col sm={12} md={2} lg={2} xl={2}>
            <div
              style={{
                display: props?.list ? props?.addVariant?.is_stock === "yes" ? "block" : "none" : props?.stockhide ? "block" : "none",
              }}
            >
              <FormControl placeholder={t("pages.add_product.stock_place")} value={props?.addVariant?.stock} name={"stock"} type={"number"} onChange={(e) => props?.addVariantchange(e)} error={t(props?.errorVariant?.stock)} />
            </div>
          </Col>
          <Col sm={4} md={props?.list ? 4 : 6} lg={4} xl={4} className="ml-auto add_variation text-end">
            {props?.list ? (
              <div
                className="mb-2 delete_div"
                onClick={props?.productDelete}
              >
                <div className="label">
                  <i className="mask_icon delete_svg white" />
                </div>
              </div>
            ) : (
              <div className="mt-2 d-flex justify-content-end">
                <ButtonPage
                  Text={t("pages.cancel")}
                  onClick={() => props?.setShowAddVariation(false)}
                  className="button-black px-4 me-1"
                  type="button"
                />
                <ButtonPage
                  Text={<>{t("pages.Save Variant")}</>}
                  className=" button-submit"
                  type="button"
                  onClick={(e) => props?.addVarianttoList(e)}
                />
              </div>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}

const mapStateToProps = (state) => ({
  language: state?.languageState?.language,
})

export default connect(mapStateToProps)(VariationboxPage);